import type { AllRouteEndpoints } from "../routeTypes";

export const appSettingsComputeCustomAttributeUsage = "/app_settings/compute_custom_attribute_usage";

export const postAppSettingsComputeCustomAttributeUsageCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/custom_attributes_data",
];
